<template>
    <div>
        <template v-if="employee === true">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left"> Employees </h1>
                <div v-if="crud_employee">
                    <router-link to="/addEmployeePersonalDetail" class="btn btn-primary float-right"> Add Employee</router-link>
                    <router-link to="/employeeBulkUpload" class="btn btn-primary float-right mr-1"> Employee Bulk Upload</router-link>
                </div>
                <div class="searching float-right mr-2">
                    <input id="customSearch" type="text" class="form-control search" autocomplete="off" />
                </div>
            </div>
            <div class="page-top mb-1 mb-3 clearfix">
                <ul class="nav nav-tabs nav-tabs-1 float-left" id="myTab" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link active" id="active-employees-tab" data-toggle="tab" href="#active-employees" role="tab" aria-controls="active" aria-selected="true">Active ({{this.active_employees_count}})</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="deleted-employees-tab" data-toggle="tab" href="#deleted-employees" role="tab" aria-controls="deleted" aria-selected="false">Deleted ({{this.deleted_employees_count}})</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="processing-employees-tab" data-toggle="tab" href="#processing-employees" role="tab" aria-controls="processing" aria-selected="false">Processing ({{ this.batch_processing_count }})</a>
                    </li>
                </ul>
            </div>
            <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade show active" id="active-employees" role="tabpanel" aria-labelledby="active-employees-tab">
                    <table id="dt-active-employees" class="table" style="width:100%">
                        <thead>
                            <tr>
                                <th style="display: none;"></th>
                                <th>Name</th>
                                <th>Designation</th>
                                <th>Phone Number</th>
                                <th>Account Title</th>
                                <th>Beneficiary</th>
                                <th>Status</th>
                                <th>Gross Salary</th>
                                <th>Profile</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                    </table>
                </div>
				<div class="tab-pane fade" id="deleted-employees" role="tabpanel" aria-labelledby="deleted-employees-tab">
					<table id="dt-deleted-employees" class="table" style="width:100%">
						<thead>
							<tr>
                                <th style="display: none;"></th>
                                <th>Name</th>
                                <th>Designation</th>
                                <th>Phone Number</th>
                                <th>Account Title</th>
                                <th>Beneficiary</th>
                                <th>Status</th>
                                <th>Gross Salary</th>
                                <th>Profile</th>
                                <th>Action</th>
                                <th>Deleted At</th>
                            </tr>
						</thead>
					</table>
				</div>
                <div class="tab-pane fade" id="processing-employees" role="tabpanel" aria-labelledby="processing-employees-tab">
					<table id="dt-processing-employees" class="table" style="width:100%">
						<thead>
							<tr>
                                <th style="display: none;"></th>
                                <th>Batch</th>
                                <th>Inserted</th>
                                <th>Updated</th>
                                <th>Discrepants</th>
                                <th>Status</th>
                                <th>Date</th>
                                <th>Action</th>
                            </tr>
						</thead>
                        
					</table>
				</div>
            </div>
        </template>
        <template v-else-if="employee === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="employee === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    var gthat = null;
    export default {
        data() {
            return {
                data : null,
                active_employees_count : 0,
                deleted_employees_count : 0,
                incomplete_profile_count : '',
                batch_processing_count : 0,
                employee : null,
                crud_employee : null
            };
        },
        mounted() {
            gthat = this;
            this.$Progress.start();
            this.can('crud_employee|employee').then(result => {
                this.crud_employee = result.crud_employee;
                this.employee = result.employee;
            }).then(result => {
                if(this.employee == true){
                    this.activeEmployeeList();
                    this.deletedEmployeeList();
                    this.batchProcessingList();
                    this.$Progress.finish();
                }
            });
        },
        methods: {
            deleteEmployee(id){
                swal.fire({
                    title: 'Are you sure?',
                    text: "You want to delete this employee !",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!',
                    cancelButtonText: 'No, cancel!',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        axios.get('/api/deleteEmployee/'+id)
                        .then(res => {
                            if(res.status == 200){

                                if(res.data == "Employee cannot be deleted")
                                {
                                    gthat.showAlertBox('info','Employee with the role of Maker, Checker, Approver Or Single Owner cannot be deleted.');
                                }
                                else if(res.data == "Employee deleted successfully")
                                {
                                    $('#dt-active-employees').DataTable().ajax.reload( json => {
                                        gthat.active_employees_count = json.recordsTotal;
                                    }, false);

                                    $('#dt-deleted-employees').DataTable().ajax.reload( json => {
                                        gthat.deleted_employees_count = json.recordsTotal;
                                    }, false);

                                    gthat.showToastBox('success','Your employee has been deleted');
                                }
                            }else{
                                gthat.showAlertBox('error','Error to delete employee');
                            }
                        })
                        .catch(err => {
                            gthat.showAlertBox('error','Error to delete employee');
                        });
                    } else if (result.dismiss === Swal.DismissReason.cancel){
                        swal.fire(
                            'Cancelled',
                            'Your decision has been cancelled',
                            'error'
                        )
                    }
                })
            },
            restoreEmployee(id){
                swal.fire({
                    title: 'Are you sure?',
                    text: "You want to restore this employee !",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, restore it!',
                    cancelButtonText: 'No, cancel!',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        axios.get('/api/undoDeleteEmployee/'+id)
                        .then(res => {
                            if(res.status == 200){
                                $('#dt-active-employees').DataTable().ajax.reload( json => {
                                    gthat.active_employees_count = json.recordsTotal;
                                }, false);

                                $('#dt-deleted-employees').DataTable().ajax.reload( json => {
                                    gthat.deleted_employees_count = json.recordsTotal;
                                }, false);
                                
                                gthat.showToastBox('success','Your employee has been restored');
                            }else{
                                gthat.showAlertBox('error','Error to restore employee');
                            }
                        })
                        .catch(err => {
                            gthat.showAlertBox('error','Error to restore employee');
                        });
                    } else if (result.dismiss === Swal.DismissReason.cancel){
                        swal.fire(
                            'Cancelled',
                            'Your decision has been cancelled',
                            'error'
                        )
                    }
                })
            },
            activeEmployeeList(){
                var activeEmployeesTable = $('#dt-active-employees').DataTable({
                    "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    processing: true,
                    serverSide: true,
                    ajax: {
                        "url": "api/listEmployees",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                    },
                    deferRender: true,
                    columns: [
                        {data: 'id', visible: false},
                        {data: 'name'},
                        {render: function(data,type,full){
                            if(full.designation != null){
                                return full.designation.name;
                            }
                        }},
                        {data: 'mobile_no'},
                         {render: function(data,type,full){
							if(full.default_beneficiary != null){
                                return full.default_beneficiary.account_title;
							}else{
								return "---";
							}
                        }},
                        {render: function(data,type,full){
							if(full.default_beneficiary != null){
                                return full.default_beneficiary.bank_name+'/'+full.default_beneficiary.account_number;
							}else{
								return "Beneficiary not set";
							}
                        }},
                        {data: 'status'},
                        {render: function(data,type,full){
                            return new Intl.NumberFormat().format(full['net_salary']);
						}},
                        {data: 'id', render: function(data,type,full){
                            if(full['wizard_cycle'] == 7){
                                return 'Complete';
                            }else{
                                return 'Incomplete';
                            }
                        }},
                        {data: 'id', sorting: false, render: function(data,type,full){
                            if(full['wizard_cycle'] == 0){
                                var $url = '/addEmployeePersonalDetail/'+full['id'];
                            }else if(full['wizard_cycle'] == 1){
                                var $url = '/addEmployeeBasicDetail/'+full['id'];
                            }else if(full['wizard_cycle'] == 2){
                                var $url = '/addEmployeeTaxDetail/'+full['id'];
                            }else if(full['wizard_cycle'] == 3){
                                var $url = '/addEmployeePaymentDetail/'+full['id'];
                            }else if(full['wizard_cycle'] == 4){
                                var $url = '/addEmployeeTimeoff/'+full['id'];
                            }else if(full['wizard_cycle'] == 5){
                                var $url = '/addEmployeeUserPermission/'+full['id'];
                            }else if(full['wizard_cycle'] == 6){
                                var $url = '/addEmployeeWelcome/'+full['id'];
                            }else if(full['wizard_cycle'] == 7){
                                var $url = '/editEmployee/'+full['id'];
                            }
                            if(full['delete_able'] == true && gthat.crud_employee){
                                return '<td class="text-center"> <a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="Edit" class="action edit"> <i class="fas fa-pencil-alt"></i> </a> <a href="javascript:void(0);" onclick="VueComponents.employeesComponent.methods.deleteEmployee('+full.id+')" data-toggle="tooltip" data-placement="top" title="Delete" class="action delete"> <i class="fas fa-trash-alt"></i> </a></td>';
                            }else{
                                return '<td class="text-center"> <a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="Edit" class="action edit"> <i class="fas fa-pencil-alt"></i> </a></td>';
                            }
                        }}
                    ],
                    "order": [[ 0, "desc" ]],
                    "columnDefs": [ 
                        { "orderable": false, "targets": [2,4,5,7] }
                    ],
                    "initComplete": (settings, json) => {
                        this.$Progress.finish();
                        gthat.active_employees_count = json.recordsTotal;
                    }
                });
                $('#customSearch').on( 'keyup', function () {
                    activeEmployeesTable.search(this.value).draw();
                });
                // $("#customSearch").keypress(function(e) {
                //     // You can use $(this) here, since this once again refers to your text input
                //     if(e.which === 13) {
                //         e.preventDefault(); // Prevent form submit
                //         activeEmployeesTable.search($(this).val()).draw();
                //     }
                // });
            },
            deletedEmployeeList(){
                var deletedEmployeesTable = $('#dt-deleted-employees').DataTable({
                    "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    processing: true,
                    serverSide: true,
                    ajax: {
                        "url": "api/listDeletedEmployees",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                    },
                    deferRender: true,
                    columns: [
                        {data: 'id', visible: false},
                        {data: 'name'},
                        {render: function(data,type,full){
                            if(full.designation != null){
                                return full.designation.name;
                            }
                        }},
                        {data: 'mobile_no'},
                         {render: function(data,type,full){
							if(full.default_beneficiary != null){
                                return full.default_beneficiary.account_title;
							}else{
								return "---";
							}
                        }},
                        {render: function(data,type,full){
							if(full.default_beneficiary != null){
                                return full.default_beneficiary.bank_name+'/'+full.default_beneficiary.account_number;
							}else{
								return "Beneficiary not set";
							}
                        }},
                        {data: 'status'},
                        {render: function(data,type,full){
                            return new Intl.NumberFormat().format(full['net_salary']);
						}},
                        {data: 'id', render: function(data,type,full){
                            if(full['wizard_cycle'] == 7){
                                return 'Complete';
                            }else{
                                return 'Incomplete';
                            }
                        }},
                        {data: 'id', sorting: false, render: function(data,type,full){
                            if(full['wizard_cycle'] == 0){
                                var $url = '/addEmployeePersonalDetail/'+full['id'];
                            }else if(full['wizard_cycle'] == 1){
                                var $url = '/addEmployeeBasicDetail/'+full['id'];
                            }else if(full['wizard_cycle'] == 2){
                                var $url = '/addEmployeeTaxDetail/'+full['id'];
                            }else if(full['wizard_cycle'] == 3){
                                var $url = '/addEmployeePaymentDetail/'+full['id'];
                            }else if(full['wizard_cycle'] == 4){
                                var $url = '/addEmployeeTimeoff/'+full['id'];
                            }else if(full['wizard_cycle'] == 5){
                                var $url = '/addEmployeeUserPermission/'+full['id'];
                            }else if(full['wizard_cycle'] == 6){
                                var $url = '/addEmployeeWelcome/'+full['id'];
                            }else if(full['wizard_cycle'] == 7){
                                var $url = '/editEmployee/'+full['id'];
                            }
                            if(gthat.crud_employee){
                                return '<td class="text-center"> <a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="Edit" class="action edit"> <i class="fas fa-pencil-alt"></i> </a> <a href="javascript:void(0);" onclick="VueComponents.employeesComponent.methods.restoreEmployee('+full.id+')" data-toggle="tooltip" data-placement="top" title="Restore" class="action restore"> <i class="fas fa-undo"></i> </a></td>';
                            }else{
                                return '<td class="text-center"> <a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="Edit" class="action edit"> <i class="fas fa-pencil-alt"></i> </a></td>';
                            }
                        }},
                        {data: 'deleted_at', orderable:false, render: function(data, type, full){
                            if(full['deleted_at'] == null || full['deleted_at'] == '0000-00-00 00:00:00'){
                                return '-';
                            }else{
                                return  '' + moment(full['deleted_at']).format('MMM D, Y') + '';
                            }
                        }}
                    ],
                    "order": [[ 0, "desc" ]],
                    "columnDefs": [
                        { "orderable": false, "targets": [2,4,5,7] }
                    ],
                    "initComplete": (settings, json) => {
                        this.$Progress.finish();
                        gthat.deleted_employees_count = json.recordsTotal;
                    }
                });
                $('#customSearch').on( 'keyup', function () {
                    deletedEmployeesTable.search(this.value).draw();
                });
            },
            batchProcessingList(){
                var batchProcessingTable = $('#dt-processing-employees').DataTable({
                    "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    processing: true,
                    serverSide: true,
                    ajax: {
                        "url": "api/listEmployeesProcessing",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                    },
                    deferRender: true,
                    columns: [
                        {data: 'sheet_id', visible: false},
                        {data: 'file_name'},
                        {data: 'inserted'},
                        {data: 'updated'},
                        {data: 'discrepants'},
                        {data: 'status'},
                        {data: 'batch_date'},
                        {data: 'sheet_id', sorting: false, render: function(data,type,full){
                            if(full.discrepants > 0){
                                return '<td class="text-center"> <a href="javascript:void(0);" onclick="downloadDiscrepants('+data+')" data-toggle="tooltip" data-placement="top" title="Download & Delete"><i class="far fa-file-excel" aria-hidden="true"></i> Discrepants</a></td>';
                            }else{
                                return '<td class="text-center"></td>';
                            }
                        }}
                        
                    ],
                    "order": [[ 0, "desc" ]],
                    // "columnDefs": [ 
                    //     { "orderable": false, "targets": [2,4,5,7] }
                    // ],
                    "initComplete": (settings, json) => {
                        this.$Progress.finish();
                        gthat.batch_processing_count = json.precessingTotal;
                    }
                });
                window.batchProcessingTable = batchProcessingTable;
            }
        }
    }
</script>
